import { ChangeDetectionStrategy, Component, OnInit, computed } from '@angular/core';
import { CoreAppComponent } from 'src/app/core/core-app.component.js';
import { ResponseService } from 'src/app/services/response.service.js';

@Component({
    templateUrl: './global-404.component.html',
    selector: 'mod-global-404',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class Global404Component extends CoreAppComponent implements OnInit {
	public readonly pageTitle = computed<string>(() => {
		if (this.authUser()) {
			return '404';
		}

		return this.originalAppName();
	});

	public readonly goBackUrl = computed<string>(() => {
		if (this.authUser()) {
			return this.dashboardUrl();
		}

		return '';
	});

	public readonly goBackText = computed<string>(() => {
		if (this.authUser()) {
			return `Back to dashboard`;
		}

		return 'Back to homepage';
	});

	constructor(responseService: ResponseService) {
		super();

		responseService.setStatusCode(404);
	}

	ngOnInit(): void {
		this.log404();
	}

	private log404(): void {
		// only log from client, not server
		if (this.isServerPlatform()) {
			return;
		}
		super.subscribeToObservable(
			this.dependencies.logService.logEvent({
				email: this.authUser()?.email,
				message: `Page not found`,
				stacktrace: 'Global404Component',
				behavior: undefined
			})
		);
	}
}
